import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemProps,
  ListItemText,
} from '@mui/material';
import { AvatarName } from '../..';
import { useTranslation } from 'react-i18next';

export function TransactionCategoryListItemContent({ category }: { category: string }) {
  const { t } = useTranslation('transactionCategory');
  const name = t(category, { defaultValue: category });
  return (
    <>
      <ListItemAvatar>
        <AvatarName name={name} />
      </ListItemAvatar>
      <ListItemText primary={name} />
    </>
  );
}

export type TransactionCategoryListItemProps = ListItemProps<'li', { category: string }>;

export function TransactionCategoryListItem({
  category,
  ...props
}: TransactionCategoryListItemProps) {
  return (
    <ListItem {...props}>
      <TransactionCategoryListItemContent category={category} />
    </ListItem>
  );
}

export type TransactionCategoryListItemButtonProps<
  RootComponent extends React.ElementType = 'div',
> = ListItemButtonProps<RootComponent, { category: string }>;

export function TransactionCategoryListItemButton<RootComponent extends React.ElementType = 'div'>({
  category,
  ...props
}: TransactionCategoryListItemButtonProps<RootComponent>) {
  return (
    <ListItemButton {...props}>
      <TransactionCategoryListItemContent category={category} />
    </ListItemButton>
  );
}
